export default __webpack_public_path__ + "static/media/premier-league-bg.9fd7763e.png";